import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

// ---- Credit cards ----
export const getAllCreditCards = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "credit_cards/get_all_credit_card",
      {
        requester: getUser(),
        token: getToken(),
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

// GET SINGLE
export const getCreditCard = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "credit_cards/get_credit_card",
      {
        requester: getUser(),
        token: getToken(),
        credit_card_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const searchCreditCard = async (name) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "credit_cards/search",
      {
        requester: getUser(),
        token: getToken(),
        name: name,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

//POST
export const createCreditCard = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "credit_cards/create",
      {
        requester: getUser(),
        token: getToken(),
        name: data.name,
        card_name: data.card_name,
        card_no: data.card_no,
        issuing_bank: data.issuing_bank,
        credit_limit: data.credit_limit,
        statement_date: data.statement_date,
        due_date: data.due_date,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateCreditCard = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "credit_cards/update",
      {
        requester: getUser(),
        token: getToken(),
        credit_card_id: data.id,
        name: data.name,
        card_name: data.card_name,
        card_no: data.card_no,
        issuing_bank: data.issuing_bank,
        credit_limit: data.credit_limit,
        statement_date: data.statement_date,
        due_date: data.due_date,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteCreditCard = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "credit_cards/delete",
      {
        requester: getUser(),
        token: getToken(),
        credit_card_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

// ---- Card transactions ----
export const getCardTransactions = async (creditCardId) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "credit_card_transactions/get_all_transaction",
      {
        requester: getUser(),
        token: getToken(),
        credit_card_id: creditCardId,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const addCardTransaction = async (formData) => {
  try {
    formData.append("requester", getUser());
    formData.append("token", getToken());

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "credit_card_transactions/add",
      formData,
      true // isFormData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteCardTransaction = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "credit_card_transactions/delete",
      {
        requester: getUser(),
        token: getToken(),
        credit_card_transaction_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};